import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

type SyncMeta = {
  id: number;
  last_synced_at: string | null;
};

export const useSyncMeta = () =>
  useQuery<SyncMeta | null>({
    queryKey: ['sync-meta'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('event_sync_meta')
        .select('*')
        .order('id', { ascending: true })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return (data as SyncMeta) ?? null;
    },
    staleTime: 60_000,
  });

